var app = {
    container: {
        flex: 1
    }
}
export default app;